import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import Paging, {BasePqForm} from "biz-ts/src/api/Paging";
import MqttEventWrapper, {MqttEventType} from "@/model/MqttEventWrapper";
import ObjectUtil from "tools-ts/src/util/ObjectUtil";
import _ from 'lodash';

@Singleton
export default abstract class MqttEventApi {
    abstract paging(form: EventPqForm): Promise<Paging<MqttEventWrapper>>
}

class MqttApiImpl extends BaseApi implements MqttEventApi {

    protected urlPrefix = 'mqtt/event'

    async paging(form: EventPqForm): Promise<Paging<MqttEventWrapper>> {
        const f = ObjectUtil.deepClone(form)
        if (_.isEmpty(f.eventType)) f.eventType = undefined
        const paging: Paging<MqttEventWrapper> = await this.axios.get('paging', {params: f})
        paging.content.forEach(wrapper => {
            wrapper.eventJson = JSON.stringify(wrapper.event)
        })
        return paging
    }
}

export class EventsForm {
}

export class EventPqForm extends BasePqForm {
    eventType?: MqttEventType

    constructor(eventType: MqttEventType | undefined = undefined) {
        super()
        this.eventType = eventType;
    }
}

Container.bind(MqttEventApi).to(MqttApiImpl)
